module.exports = __webpack_public_path__ + "static/media/ePosterHotel.98be3f5c.jpg";